<template>
    <div class="dropdown float-left">
        <button type="button" :disabled="spectrumLoading"
                class="py-2 px-3 standard-dropdown border-1 border-teal hover:bg-followup-nav  rounded-full hover:text-white mx-1 text-teal text-followup-nav focus:outline-none"
                id="spectrumOptionDropDown" data-toggle="dropdown"
                aria-haspopup="true" aria-expanded="false">
            <i class="fa fa-spin fa-spinner text-grey-darkest spectrum-project-loader" aria-hidden="true" v-if="spectrumLoading"></i>
            Spectrum Options <i class="fa fa-caret-down mx-1"></i>
        </button>
        <div class="standard-dropdown dropdown-menu dropdown-menu-right" aria-labelledby="spectrumOptionDropDown">
            <button v-if="canErpCreate" type="button" class="dropdown-item py-2" :disabled="spectrumProjectMapping.direction === 'one-way-followup' || project.spectrum_project_no" @click.prevent.stop="pushProjectToSpectrum">
                Connect/Push to Spectrum
            </button>
            <button v-if="canErpUpdate" type="button" class="dropdown-item py-2" :disabled="spectrumProjectMapping.direction === 'one-way-followup' || !project.spectrum_project_no" @click.prevent.stop="pushProjectToSpectrum">
                Update Job on Spectrum
            </button>
            <button v-if="canErpSync" type="button" class="dropdown-item py-2" :disabled="spectrumProjectMapping.direction === 'one-way-third-party'"  @click.prevent="syncProjectFromSpectrum" >
                Sync from Spectrum
            </button>
            <span v-if="!project.spectrum_project_no">
                <button type="button" class="dropdown-item py-2" :disabled="spectrumProjectMapping.direction === 'one-way-third-party'"  @click.prevent="syncProjectFromSpectrum">
                    Pull Income Cost Summary
                </button>
            </span>
            <span v-else>
                <button type="button" class="dropdown-item py-2" :disabled="spectrumProjectMapping.direction === 'one-way-third-party'"  @click.prevent="syncProjectSpectrumInvoice">
                    Pull Income Cost Summary
                </button>
            </span>
        </div>

        <!--    Select job type for a job to push to spectrum    -->
        <div class="modal fade" id="spectrumJobTypeSelectionModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true" data-backdrop="static" data-keyboard="false">
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLongTitle">Select Spectrum Job Type</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeModal('spectrumJobTypeSelectionModal', true)">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row container">
                            <label class="mb-0">Select Type</label>
                            <multiselect
                                id="selectSpectrumJobType"
                                v-model="selectedJobType"
                                :options="spectrumJobTypes"
                                :multiple="false"
                                :close-on-select="true"
                                :clear-on-select="false"
                                :preserve-search="false"
                                :taggable="false"
                                open-direction="below"
                                placeholder="Pick a type"
                                :showLabels="false"
                                label="Description"
                                track-by="Description"
                                :preselect-first="false"
                            >
                            </multiselect>
                        </div>
                        <div class="row container mt-2">
                            <label class="mb-0">Select Cost Center</label>
                            <multiselect
                                id="selectCostCenter"
                                v-model="selectedCostCenter"
                                :options="spectrumCostCenters"
                                :multiple="false"
                                :close-on-select="true"
                                :clear-on-select="false"
                                :preserve-search="false"
                                :taggable="false"
                                open-direction="below"
                                placeholder="Pick a cost center"
                                :showLabels="false"
                                label="Cost_Center_Description"
                                track-by="Cost_Center_Code"
                                :preselect-first="false"
                            >
                            </multiselect>
                        </div>
                        <div class="row container mt-2">
                            <label class="mb-0">Select Is Job Taxable</label>
                            <multiselect
                                id="selectJobTaxable"
                                v-model="taxable"
                                :options="spectrumJobTaxable"
                                :multiple="false"
                                :close-on-select="true"
                                :clear-on-select="false"
                                :preserve-search="false"
                                :taggable="false"
                                open-direction="below"
                                placeholder="Is Job Taxable"
                                :showLabels="false"
                                label="Description"
                                track-by="id"
                                :preselect-first="false"
                            >
                            </multiselect>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal" @click="closeModal('spectrumJobTypeSelectionModal', true)">Close</button>
                        <button type="button" class="btn btn-primary" :disabled="!taxable || !selectedCostCenter || !selectedJobType" @click="closeModal('spectrumJobTypeSelectionModal');openModal('spectrumCustomerSelectionModal')">Select</button>
                    </div>
                </div>
            </div>
        </div>

        <!--    Select company contact to push with job    -->
        <div class="modal" id="spectrumCustomerSelectionModal" tabindex="-1" data-backdrop="static" data-keyboard="false">
            <div class="modal-dialog modal-dialog-centered modal-lg">
                <div class="modal-content">
                    <div class="modal-header bg-white">
                        <h5 class="modal-title text-teal font-medium">Select Contact</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeModal('spectrumCustomerSelectionModal', true)">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body bg-white">
                        <div class="row">
                            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 form-group">
                                <label for="user">Select contact to associate with the Spectrum Job</label>
                                <multiselect
                                    class="cursor-pointer w-full"
                                    :options="companyContacts"
                                    v-model="selectedCustomerForSpectrumJob"
                                    label="name"
                                    placeholder="Search and Select..."
                                    :multiple="false"
                                    track-by="id"
                                    :show-labels="false"
                                    :taggable="true"
                                    :close-on-select="true"
                                >
                                </multiselect>
                            </div>
                        </div>
                        <div v-if="selectedCustomerForSpectrumJob && selectedCustomerForSpectrumJob.spectrum_customer_no" class="text-sm mb-3 text-teal">The contact is synced already</div>
                        <div v-if="selectedCustomerForSpectrumJob && !selectedCustomerForSpectrumJob.spectrum_customer_no" class="text-sm mb-3 text-teal">Note: You have selected a contact that is not synced with Spectrum. Clicking on Push will link the contact to an existing customer on Spectrum if the email domain matches. If email domain does not match, a new customer will be created on Spectrum.</div>

                    </div>
                    <div class="modal-footer">
                        <button type="button" class="py-2 px-3 border-radius-25 hover:bg-followup-nav hover:text-white text-followup-nav focus:outline-none" @click.prevent.stop="closeModal('spectrumCustomerSelectionModal', true)">Cancel</button>
                        <button type="button" class="btn btn-primary" @click.prevent="closeModal('spectrumCustomerSelectionModal');checkCustomerSpectrumStatus()" :disabled="!this.selectedCustomerForSpectrumJob">Push</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" id="spectrumTaxCodeSelectionModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true" data-backdrop="static" data-keyboard="false">
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLongTitle">Select Spectrum Tax Code</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeModal('spectrumTaxCodeSelectionModal')">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div v-if="spectrumTaxCodes.length > 0 && spectrumTermsCodes.length > 0">
                            <div class="row container">
                                <label class="mb-0">Select Tax Code</label>
                                <multiselect
                                    id="selectSpectrumTaxCode"
                                    v-model="selectedTaxCode"
                                    :options="spectrumTaxCodes"
                                    :multiple="false"
                                    :close-on-select="true"
                                    :clear-on-select="false"
                                    :preserve-search="false"
                                    :taggable="false"
                                    open-direction="below"
                                    placeholder="Pick a tax code"
                                    :showLabels="false"
                                    label="description"
                                    track-by="id"
                                    :preselect-first="false"
                                >
                                </multiselect>
                            </div>
                            <div class="row container mt-2">
                                <label class="mb-0">Select Terms Code</label>
                                <multiselect
                                    id="selectSpectrumTermsCode"
                                    v-model="selectedTermsCode"
                                    :options="spectrumTermsCodes"
                                    :multiple="false"
                                    :close-on-select="true"
                                    :clear-on-select="false"
                                    :preserve-search="false"
                                    :taggable="false"
                                    open-direction="below"
                                    placeholder="Pick terms code"
                                    :showLabels="false"
                                    label="Terms_Description"
                                    track-by="Terms_Description"
                                    :preselect-first="false"
                                >
                                </multiselect>
                            </div>

                            <div class="row container mt-2" v-if="spectrumCustomerCodeId">
                                <label class="mb-0">Customer Code</label>
                                <input type="text" class="form-control" v-model="customCustomerCode"  max="10" id="customCustomerCode"/>
                            </div>
                        </div>
                        <div class="modal-body text-center" v-else>
                            <i class="fa fa-spin fa-spinner text-grey-darkest spectrum-project-loader" aria-hidden="true"></i>
                            Fetching Spectrum Tax Codes
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal" @click="closeModal('spectrumTaxCodeSelectionModal')">Close</button>
                        <button type="button" class="btn btn-primary" :disabled="spectrumTaxCodes.length === 0 || spectrumTermsCodes.length === 0 || !selectedTermsCode || !selectedTaxCode || (spectrumCustomerCodeId && !customCustomerCode)" @click="closeModal('spectrumTaxCodeSelectionModal');pushToSpectrum()">Push</button>
                    </div>
                </div>
            </div>
        </div>

        <!--    modal to confirm the update on spectrum    -->
        <div class="modal" tabindex="-1" role="dialog" id="updateSpectrumJobModal" >
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title text-teal font-medium">WARNING! - This will over-write the info of the synced Spectrum Job.</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <p>This will replace or update the Spectrum Job that is synced with this project. Are you sure you want to proceed?</p>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="py-2 px-3 border-radius-25 hover:bg-followup-nav hover:text-white text-followup-nav focus:outline-none" @click.prevent="closeModal('updateSpectrumJobModal')">Cancel</button>
                        <button type="button" class="btn btn-primary" @click.prevent="updateJobOnSpectrum">Confirm</button>
                    </div>
                </div>
            </div>
        </div>

        <!--    modal to confirm the sync from spectrum to followup    -->
        <div class="modal" tabindex="-1" role="dialog" id="syncSpectrumJobConfirmModal" >
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title text-teal font-medium">WARNING! - This will over-write some of the Project fields.</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <p>This will overwrite certain fields of this project with info from the Spectrum Job.</p>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="py-2 px-3 border-radius-25 hover:bg-followup-nav hover:text-white text-followup-nav focus:outline-none" @click.prevent="closeModal('syncSpectrumJobConfirmModal')">Cancel</button>
                        <button type="button" class="btn btn-primary" @click.prevent="pullJobFromSpectrum()">Confirm</button>
                    </div>
                </div>
            </div>
        </div>

        <!--    modal to select the spectrum and followup contact for sync    -->
        <div class="modal" id="syncJobFromSpectrumModal" tabindex="-1" data-backdrop="static" data-keyboard="false">
            <div class="modal-dialog modal-dialog-centered modal-lg">
                <div class="modal-content">
                    <div class="modal-header bg-white">
                        <h5 class="modal-title text-teal font-medium" v-if="!syncFromSpectrumStepTwo">This project is not synced with a Spectrum Job</h5>
                        <h5 class="modal-title text-teal font-medium" v-else>WARNING! - This will over-write some of the Project fields.</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeModal('syncJobFromSpectrumModal')">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body bg-white">
                        <div class="row" v-if="!syncFromSpectrumStepTwo">
                            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 form-group">
                                <label for="user">Select the Spectrum Job to sync this project with</label>
                                <div v-if="fetchingSpectrumJobs" class="spinner text-sm text-teal">
                                    Fetching jobs from Spectrum...
                                </div>
                                <multiselect
                                    v-model="selectedSpectrumJob"
                                    :options="jobsFromSpectrum"
                                    @search-change="onSyncSpectrumInput"
                                    label="name"
                                    track-by="source_id"
                                    :multiple="false"
                                    placeholder="Search Spectrum job..."
                                    :closeOnSelect="true"
                                ></multiselect>

                            </div>
                            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-right">
                                <button type="button" class="py-2 px-3 border-radius-25 hover:bg-followup-nav hover:text-white text-followup-nav focus:outline-none" @click.prevent.stop="closeModal('syncJobFromSpectrumModal')">Cancel</button>
                                <button type="button" class="btn btn-primary" :disabled="!selectedSpectrumJob" @click.prevent="() => syncFromSpectrumStepTwo = true">Next</button>
                            </div>
                        </div>
                        <div class="row" v-else>
                            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                <p>This will overwrite certain fields of this project with info from the Spectrum Job.</p>
                            </div>
                            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-right">
                                <button type="button" class="py-2 px-3 border-radius-25 hover:bg-followup-nav hover:text-white text-followup-nav focus:outline-none" @click.prevent.stop="closeModal('syncJobFromSpectrumModal')">Cancel</button>
                                <button type="button" class="btn btn-primary" :disabled="!selectedSpectrumJob" @click.prevent="pullJobFromSpectrum">Confirm</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!--    modal to confirm syncing of already connected spectrum job customer     -->
        <div class="modal" tabindex="-1" role="dialog" id="updateSpectrumSyncedCustomerConfirmModal" >
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title text-teal font-medium">WARNING! - This will over-write the info of the Synced Spectrum Customer.</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <p>This company along with the another contact "{{this.syncedOtherCompanyContact ? this.syncedOtherCompanyContact.name : ''}}" is currently linked with Spectrum
                            customer with customer number "{{this.syncedOtherCompanyContact ? this.syncedOtherCompanyContact.spectrum_customer_no : ''}}". Would you like to overwrite the contact details on Spectrum with the contact "{{this.selectedCustomerForSpectrumJob ? this.selectedCustomerForSpectrumJob.name : ''}}"?</p>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="py-2 px-3 border-radius-25 hover:bg-followup-nav hover:text-white text-followup-nav focus:outline-none" @click.prevent="updateSyncedCustomerOnSpectrum(false)">No</button>
                        <button type="button" class="btn btn-primary" @click.prevent="updateSyncedCustomerOnSpectrum(true)">Yes</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal" tabindex="-1" role="dialog" id="pushProjectWithOutCompanyModal" >
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title text-teal font-medium">WARNING! - This will over-write the info of the Synced Spectrum Customer.</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click.prevent="closeModal('pushProjectWithOutCompanyModal', true)">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <p>You have not mapped the company/residential contact field in the ERP settings. Would you like to create a Spectrum job without a customer associated?</p>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="py-2 px-3 border-radius-25 hover:bg-followup-nav hover:text-white text-followup-nav focus:outline-none" @click.prevent="closeModal('pushProjectWithOutCompanyModal');pushProjectWithoutCustomer(false);">No</button>
                        <button type="button" class="btn btn-primary" @click.prevent="closeModal('pushProjectWithOutCompanyModal');pushProjectWithoutCustomer(true);">Yes</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal" id="syncJobFromSpectrumForChangeOrderModal" tabindex="-1" data-backdrop="static" data-keyboard="false">
            <div class="modal-dialog modal-dialog-centered modal-lg">
                <div class="modal-content">
                    <div class="modal-header bg-white">
                        <h5 class="modal-title text-teal font-medium">Select Spectrum Job</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeModal('syncJobFromSpectrumForChangeOrderModal')">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body bg-white">
                        <div class="row">
                            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 form-group">
                                <label for="user">This project is currently not synced with Spectrum. Please select a Job on Spectrum to sync this with</label>
                                <div v-if="fetchingSpectrumJobs" class="spinner text-sm text-teal">
                                    Fetching jobs from Spectrum...
                                </div>
                                <multiselect
                                    v-model="selectedSpectrumJobForChangeOrders"
                                    :options="jobsFromSpectrum"
                                    @search-change="onSyncSpectrumInput"
                                    label="name"
                                    track-by="source_id"
                                    :multiple="false"
                                    placeholder="Search Spectrum job..."
                                    :closeOnSelect="true"
                                ></multiselect>

                            </div>
                            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-right">
                                <button type="button" class="py-2 px-3 border-radius-25 hover:bg-followup-nav hover:text-white text-followup-nav focus:outline-none" @click.prevent.stop="closeModal('syncJobFromSpectrumForChangeOrderModal')">Cancel</button>
                                <button type="button" class="btn btn-primary" :disabled="!selectedSpectrumJobForChangeOrders" @click.prevent="linkJobForChangeOrdersFromSpectrum">Sync</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal" id="syncSpectrumChangeOrderModal" tabindex="-1" data-backdrop="static" data-keyboard="false">
            <div class="modal-dialog modal-dialog-centered modal-lg">
                <div class="modal-content">
                    <div class="modal-header bg-white">
                        <h5 class="modal-title text-teal font-medium">Select Spectrum Change Order</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeModal('syncSpectrumChangeOrderModal')">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body bg-white">
                        <div class="row">
                            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 form-group">
                                <label for="user">Select Spectrum Change Order</label>
                                <multiselect
                                    v-model="selectedSpectrumChangeOrder"
                                    :options="jobChangeOrders"
                                    label="name"
                                    track-by="name"
                                    :multiple="false"
                                    placeholder="Select Spectrum Change order..."
                                    :closeOnSelect="true"
                                ></multiselect>

                            </div>
                            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-right">
                                <button type="button" class="py-2 px-3 border-radius-25 hover:bg-followup-nav hover:text-white text-followup-nav focus:outline-none" @click.prevent.stop="closeModal('syncSpectrumChangeOrderModal')">Cancel</button>
                                <button type="button" class="btn btn-primary" :disabled="!selectedSpectrumChangeOrder" @click.prevent="closeModal('syncSpectrumChangeOrderModal');openModal('updateSpectrumSyncedChangeOrderConfirmModal')">Select</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal" tabindex="-1" role="dialog" id="updateSpectrumSyncedChangeOrderConfirmModal" >
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title text-teal font-medium">WARNING! - Replace Change Order fields with data from Spectrum?</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <p>This will pull in data from a Change Order in Spectrum and replace the fields on Followup, based on the fields mapped in the settings.</p>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-danger" @click.prevent="syncJobChangeOrder()">Confirm</button>
                        <button type="button" class="btn btn-primary" @click.prevent="closeModal('updateSpectrumSyncedChangeOrderConfirmModal')">Cancel</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal" tabindex="-1" role="dialog" id="pushChangeOrderSpectrumConfirmModal" >
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title text-teal font-medium">WARNING! - Push Change Order fields to Spectrum?</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <p>This will push the Change Order data to Spectrum, based on the fields mapped in the settings.</p>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-danger" @click.prevent="pushChangeOrderToSpectrumConfirm()">Confirm</button>
                        <button type="button" class="btn btn-primary" @click.prevent="closeModal('pushChangeOrderSpectrumConfirmModal')">Cancel</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal" tabindex="-1" role="dialog" id="updateChangeOrderSpectrumConfirmModal" >
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title text-teal font-medium">WARNING! - Update Change Order fields to Spectrum?</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <p>This will update the Change Order data to Spectrum, based on the fields mapped in the settings.</p>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-danger" @click.prevent="updateChangeOrderToSpectrumConfirm()">Confirm</button>
                        <button type="button" class="btn btn-primary" @click.prevent="closeModal('updateChangeOrderSpectrumConfirmModal')">Cancel</button>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import axios from "axios";
import Multiselect from "vue-multiselect";

export default {
    name: 'project-spectrum',
    components: {Multiselect},
    props: ['project', 'companyContacts', 'spectrumProjectMapping', 'projectSalesStatusState', 'spectrumJobNumberCustomFieldId', 'hasSpectrumCompanyContactMapping', 'hasSpectrumResidentialContactMapping', 'spectrumCustomerCodeId', 'spectrumCustomIdAutoGenerated',
            'canErpCreate', 'canErpUpdate', 'canErpSync'],
    data() {
        return {
            spectrumJobTypes: [{'Description' : 'Fixed Price'},{'Description' : 'Time & Material'},{'Description' : 'Cost Plus'},{'Description' : 'Unit Price'}],
            selectedJobType: null,
            selectedCustomerForSpectrumJob: null,
            selectedSpectrumJob: null,
            jobsFromSpectrum: [],
            syncFromSpectrumStepTwo: false,
            fetchingSpectrumJobs: false,
            syncedOtherCompanyContact: null,
            updateCustomerContactInfo: false,
            customJobNumber: null,
            pushCustomerToSpectrum: false,
            selectedSpectrumJobForChangeOrders: null,
            selectedSpectrumChangeOrder: null,
            jobChangeOrders: [],
            selectedProjectChangeOrderIndex: null,
            spectrumLoading: false,
            taxable: null,
            spectrumJobTaxable: [{"id": "N", "Description" : "No"}, {"id": "Y", "Description" : "Yes"}],
            spectrumCostCenters: [],
            selectedCostCenter: null,
            spectrumTaxCodes: [],
            spectrumTermsCodes: [],
            selectedTaxCode: null,
            selectedTermsCode: null,
            customCustomerCode: null,
            isCustomIdAutoGenerated: false,
            nextAutoGeneratedStartFrom: null,
        }
    },
    created() {
        this.fetchCostCenters();
        this.fetchSpectrumCodes();
        this.debouncedFilterOptions = _.debounce(this.filterOptions, 500);
    },
    mounted() {
        if(this.hasSpectrumResidentialContactMapping && this.hasSpectrumCompanyContactMapping){
            this.pushCustomerToSpectrum = true;
        }
    },
    methods: {
        fetchSpectrumCodes(){
            let self = this;
            self.loadingSpectrumTaxCodes = true;
            axios.post(route('api.spectrum.get-spectrum-codes')).then((response) => {
                self.loadingSpectrumTaxCodes = false;
                self.spectrumTaxCodes = response.data.taxCodes;
                self.spectrumTermsCodes = response.data.termsCodes;
            });
        },
        fetchCostCenters(){
            let self = this;
            axios.post(route('api.spectrum.get-spectrum-cost-centers')).then((response) => {
                self.spectrumCostCenters = response.data.costCenters?.length > 0 ? response.data.costCenters.map(costCenter => (
                    {
                        "Company_Code" : costCenter.Company_Code,
                        "Cost_Center_Code" : costCenter.Cost_Center_Code.trim(),
                        "Cost_Center_Description" : costCenter.Cost_Center_Description.trim()
                    }
                    )) : [];
            });
        },
        pushProjectToSpectrum(){
            let self = this;

            if(this.spectrumJobNumberCustomFieldId && !self.$parent.$refs.CustomFields.form[this.spectrumJobNumberCustomFieldId]){

                if(this.spectrumCustomIdAutoGenerated){
                    this.customJobNumber = this.generateSpectrumCustomId(this.spectrumJobNumberCustomFieldId);

                    this.$parent.$refs.CustomFields.form[this.spectrumJobNumberCustomFieldId] = this.customJobNumber;

                    if(this.project.spectrum_project_no || this.project.agave_project_no){
                        this.openModal('updateSpectrumJobModal');
                    }else{
                        this.openModal('spectrumJobTypeSelectionModal');
                    }

                }else{
                    this.getToast().fire({
                        type: 'error',
                        title: 'Spectrum Job # is required'
                    });
                }
            }else{

                self.customJobNumber = self.$parent.$refs.CustomFields.form[self.spectrumJobNumberCustomFieldId] ?? null;

                if(self.project.spectrum_project_no || self.project.agave_project_no){
                    self.openModal('updateSpectrumJobModal');
                }else{

                    self.openModal('spectrumJobTypeSelectionModal');
                }
            }
        },
        syncProjectFromSpectrum(){
            if(this.project.agave_project_no){
                $('#syncSpectrumJobConfirmModal').modal('show');
            }else{
                $('#syncJobFromSpectrumModal').modal('show');
            }
        },
        openModal(modalId) {
            $('#'+modalId).modal('show');
            if(modalId === 'spectrumCustomerSelectionModal'){
                this.selectedCustomerForSpectrumJob = null;
            }
        },
        closeModal(modalId, isCancelled = false) {
            $('#'+modalId).modal('hide');
            const modalIds = ['spectrumJobTypeSelectionModal', 'spectrumCustomerSelectionModal', 'pushProjectWithOutCompanyModal']
            if(isCancelled && modalIds.includes(modalId)) {
                this.$emit('pushProjectCancelled');
            }
        },
        pushToSpectrum(){
            let self = this;
            if(self.selectedJobType == null || self.selectedJobType === ''){
                self.getToast().fire({
                    type: 'error',
                    title: 'Please select type'
                });
                return false;
            }


            if(self.selectedCostCenter == null || self.selectedCostCenter === ''){
                self.getToast().fire({
                    type: 'error',
                    title: 'Please select cost center for job'
                });
                return false;
            }

            if(self.taxable == null || self.taxable === ''){
                self.getToast().fire({
                    type: 'error',
                    title: 'Please select if job is taxable'
                });
                return false;
            }

            if(!self.selectedCustomerForSpectrumJob.agave_customer_no){
                if(self.spectrumCustomerCodeId && !self.customCustomerCode){
                    self.getToast().fire({
                        type: 'error',
                        title: 'Please enter customer code'
                    });
                    return false;
                }else if(self.selectedCustomerForSpectrumJob.is_contact_residential && (!self.selectedTermsCode && !self.selectedTaxCode)){
                    this.openModal('spectrumTaxCodeSelectionModal');
                    return false;

                }
            }

            let data = {
                contact: self.selectedCustomerForSpectrumJob,
                projectId: self.project.id,
                jobType: self.selectedJobType.Description,
                costCenter: self.selectedCostCenter.Cost_Center_Code,
                updateCustomerContact: self.updateCustomerContactInfo,
                agaveCustomerId: self.syncedOtherCompanyContact ? self.syncedOtherCompanyContact.agave_customer_no : null,
                spectrumCustomerId: self.syncedOtherCompanyContact ? self.syncedOtherCompanyContact.spectrum_customer_no : null,
                customJobNumber: self.customJobNumber,
                spectrumJobNumberCustomFieldId: self.spectrumJobNumberCustomFieldId,
                pushWithContact: self.pushCustomerToSpectrum,
                taxable: self.taxable.id,
                taxCodeId: self.selectedTaxCode ? self.selectedTaxCode.id : null,
                termsCode: self.selectedTermsCode ? self.selectedTermsCode.Terms_Description : null,
                spectrumCustomerCodeId: self.spectrumCustomerCodeId,
                customCustomerCode: self.customCustomerCode,
                isCustomIdAutoGenerated: self.isCustomIdAutoGenerated,
                nextAutoGeneratedStartFrom: self.nextAutoGeneratedStartFrom,
            };


           this.spectrumLoading = true;
            axios.post(route('api.spectrum.push-project-to-spectrum'), data).then((response) => {
                self.spectrumLoading = false;
               if(response.data.status == 'success'){
                   self.getToast().fire({
                       type: 'success',
                       title: response.data.message
                   });
                   self.isCustomIdAutoGenerated = false;
                   self.nextAutoGeneratedStartFrom = null;
                   setTimeout(() => {
                        window.location.reload();
                   }, 3000)
               }else{
                   this.$emit('spectrum-refresh-project-contacts');
                   if(self.isCustomIdAutoGenerated && self.nextAutoGeneratedStartFrom){
                       self.customJobNumber = null;
                       self.isCustomIdAutoGenerated = false;
                       self.nextAutoGeneratedStartFrom = null;
                       self.$parent.$refs.CustomFields.form[this.spectrumJobNumberCustomFieldId] = this.customJobNumber;
                   }
                   self.customCustomerCode = null;
                   self.getToast().fire({
                       type: 'error',
                       title: response.data.message
                   });
               }
            });

        },
        updateJobOnSpectrum(){
            let self = this;
            this.spectrumLoading = true;
            axios.post(route('api.spectrum.update-project-to-spectrum'), {projectId: this.project.id}).then((response) => {
                this.spectrumLoading = false;
                this.isCustomIdAutoGenerated = false;
                this.nextAutoGeneratedStartFrom = null;
               if(response.data.status == 'success'){
                   self.closeModal('updateSpectrumJobModal');
                   self.getToast().fire({
                       type: 'success',
                       title: response.data.message
                   });
                   setTimeout(() => {
                        window.location.reload();
                   }, 3000)
               }else{
                   self.getToast().fire({
                       type: 'error',
                       title: response.data.message
                   });
               }
            });

        },
        onSyncSpectrumInput(value) {
            if (value.length >= 3) {
                this.fetchingSpectrumJobs = true;
                this.debouncedFilterOptions(value);
            }
        },
        filterOptions(input) {
            let self = this;
            axios.post(route('api.spectrum.search-job-from-spectrum'), {search: input}).then((response) => {
                self.fetchingSpectrumJobs = false;
                if(response.data.status == 'success'){
                    self.jobsFromSpectrum = response.data.spectrumJobs;
                }else{
                    self.getToast().fire({type: 'error',title: response.data.message});
                }
            });
        },
        pullJobFromSpectrum(){
            let self = this;
           this.spectrumLoading = true;
            let data = {
                projectId: this.project.id,
                agaveJobId: this.selectedSpectrumJob ? this.selectedSpectrumJob.id : null
            }
            axios.post(route('api.spectrum.sync-project-from-spectrum'), data).then((response) => {
               this.spectrumLoading = false;
                if(response.data.status == 'success'){

                    self.closeModal('syncSpectrumJobConfirmModal');
                    self.getToast().fire({
                        type: 'success',
                        title: response.data.message
                    });
                    setTimeout(() => {
                        window.location.reload();
                    }, 3000)
                }else{
                    self.getToast().fire({
                        type: 'error',
                        title: response.data.message
                    });
                }
            });

        },
        syncProjectChangeOrdersFromSpectrum(index, changeOrder){
            this.selectedProjectChangeOrderIndex = index;
            if(this.project.spectrum_project_no){
                if(changeOrder.id && changeOrder.spectrum_change_request_no){
                    this.openModal('updateSpectrumSyncedChangeOrderConfirmModal');
                }else{
                    this.fetchJobChangeOrders()
                }
            }else{
                this.openModal('syncJobFromSpectrumForChangeOrderModal');
            }
        },
        pushChangeOrderToSpectrum(index, changeOrder){
            this.selectedProjectChangeOrderIndex = index;
            if(this.project.spectrum_project_no){
                this.openModal('pushChangeOrderSpectrumConfirmModal');
            }else{
                this.openModal('syncJobFromSpectrumForChangeOrderModal');
            }
        },
        updateChangeOrderToSpectrum(index, changeOrder){
            this.selectedProjectChangeOrderIndex = index;
            if(this.project.spectrum_project_no){
                this.openModal('updateChangeOrderSpectrumConfirmModal');
            }else{
                this.openModal('syncJobFromSpectrumForChangeOrderModal');
            }
        },
        linkJobForChangeOrdersFromSpectrum(){
            let self = this;
           this.spectrumLoading = true;
            let data = {
                projectId: this.project.id,
                agaveJobId: this.selectedSpectrumJobForChangeOrders ? this.selectedSpectrumJobForChangeOrders.id : null,
                spectrumJobId: this.selectedSpectrumJobForChangeOrders ? this.selectedSpectrumJobForChangeOrders.number : null,
            }

            axios.post(route('api.project.spectrum.link-project-from-spectrum'), data).then((response) => {
               this.spectrumLoading = false;
                self.jobChangeOrders = response.data;
                self.closeModal('syncJobFromSpectrumForChangeOrderModal');
                self.openModal('syncSpectrumChangeOrderModal');
            });
        },
        fetchJobChangeOrders(){
            let self = this;
           this.spectrumLoading = true;
            let data = {
                projectId: this.project.id,
                agaveJobId: this.project ? this.project.agave_project_no : null,
            }
            self.getToast().fire({
                type: 'success',
                title: "Fetching change orders from Spectrum"
            });
            axios.post(route('api.project.spectrum.get-project-change-orders-from-spectrum'), data).then((response) => {
               this.spectrumLoading = false;
                self.jobChangeOrders = response.data;
                self.openModal('syncSpectrumChangeOrderModal')

            });
        },
        syncJobChangeOrder(){
            let self = this;
           this.spectrumLoading = true;
           self.closeModal('updateSpectrumSyncedChangeOrderConfirmModal');

            let data = {
                projectId: this.project.id,
                agaveJobId: this.project.agave_project_no ?? null,
                selectedChangeOrder: this.selectedSpectrumChangeOrder ?? null,
                selectedProjectChangeOrderIndex: this.selectedProjectChangeOrderIndex ?? null,
                projectChangeOrder: this.$parent.change_orders[this.selectedProjectChangeOrderIndex] ?? null
            }

            axios.post(route('api.project.spectrum.sync-project-change-orders-from-spectrum'), JSON.stringify(data)).then((response) => {
               this.spectrumLoading = false;
               this.selectedSpectrumChangeOrder = null;

                if(response.data.status === 'success'){

                    self.getToast().fire({
                        type: 'success',
                        title: response.data.message
                    });
                    setTimeout(() => {
                        window.location.reload();
                    }, 3000)
                }else{
                    self.getToast().fire({
                        type: 'error',
                        title: response.data.message
                    });
                }

            });
        },
        pushChangeOrderToSpectrumConfirm(){
            let self = this;
            this.spectrumLoading = true;
            self.closeModal('pushChangeOrderSpectrumConfirmModal');
            let projectChangeOrder = this.$parent.change_orders[this.selectedProjectChangeOrderIndex] ?? null;

            axios.post(route('api.project.spectrum.push-project-change-orders-to-spectrum'), {
                projectId: this.project.id,
                changeOrderId: projectChangeOrder.id,
            }).then((response) => {
               this.spectrumLoading = false;
               this.selectedSpectrumChangeOrder = null;
                if(response.data.status === 'success'){

                    self.getToast().fire({
                        type: 'success',
                        title: response.data.message
                    });
                    setTimeout(() => {
                        window.location.reload();
                    }, 3000)
                }else{
                    self.getToast().fire({
                        type: 'error',
                        title: response.data.message,
                        timer: 10000
                    });
                    setTimeout(() => {
                        window.location.reload();
                    }, 5000)
                }

            });
        },
        updateChangeOrderToSpectrumConfirm(){
            let self = this;
            this.spectrumLoading = true;
            self.closeModal('updateChangeOrderSpectrumConfirmModal');
            let projectChangeOrder = this.$parent.change_orders[this.selectedProjectChangeOrderIndex] ?? null;

            axios.post(route('api.project.spectrum.update-project-change-orders-to-spectrum'), {
                projectId: this.project.id,
                changeOrderId: projectChangeOrder.id,
            }).then((response) => {
               this.spectrumLoading = false;
               this.selectedSpectrumChangeOrder = null;
                if(response.data.status === 'success'){

                    self.getToast().fire({
                        type: 'success',
                        title: response.data.message
                    });
                }else{
                    self.getToast().fire({
                        type: 'error',
                        title: response.data.message,
                        timer: 10000
                    });
                }

            });
        },
        checkCustomerSpectrumStatus(){
            if((this.selectedCustomerForSpectrumJob.is_contact_residential && !this.hasSpectrumResidentialContactMapping) ||
                (!this.selectedCustomerForSpectrumJob.is_contact_residential && !this.hasSpectrumCompanyContactMapping)){
                this.openModal('pushProjectWithOutCompanyModal')
            }else{
                this.pushCustomerToSpectrum = false;
                this.proceedPushToSpectrum();
            }
        },
        pushProjectWithoutCustomer(val){
            this.pushCustomerToSpectrum = val;
            this.proceedPushToSpectrum();
        },
        proceedPushToSpectrum(){
            this.updateCustomerContactInfo = false;
            this.syncedOtherCompanyContact = null;
            this.$nextTick( async ()=>{
                if(this.selectedCustomerForSpectrumJob.is_contact_residential){
                   this.pushToSpectrum();
                }else{
                    if(this.selectedCustomerForSpectrumJob.spectrum_customer_no){
                        this.pushToSpectrum();
                    }else{
                        this.checkIfCompanyIsSyncedWithSpectrum(this.selectedCustomerForSpectrumJob.company_id)
                    }
                }

            })
        },
        checkIfCompanyIsSyncedWithSpectrum(companyId){
            this.updateCustomerContactInfo = false;
            axios.post(route('api.company.check-synced-with-spectrum'), {companyId: companyId}).then((response) => {
                if(response.data.status === 'success'){
                    if(response.data.isCompanySynced && response.data.contact.id !== this.selectedCustomerForSpectrumJob.id){
                        this.syncedOtherCompanyContact = response.data.contact;
                        this.openModal('updateSpectrumSyncedCustomerConfirmModal');
                    }else{
                        // show popup to select terms and tax code id for contact creation and then proceed to push
                        this.openModal('spectrumTaxCodeSelectionModal');
                    }
                }else{
                    this.getToast().fire({
                        type: 'error',
                        title: 'Company not found'
                    });
                }
            });
        },
        updateSyncedCustomerOnSpectrum(confirmation){
            this.updateCustomerContactInfo = confirmation;
            this.closeModal('updateSpectrumSyncedCustomerConfirmModal');
            this.pushToSpectrum();
        },
        pushOrUpdateProjectToSpectrum(jobNumber = null){
            this.customJobNumber = jobNumber;
            if(this.project.spectrum_project_no || this.project.agave_project_no){
                this.openModal('updateSpectrumJobModal');
            }else{
                this.selectedCustomerForSpectrumJob = null;
                this.openModal('spectrumJobTypeSelectionModal');
            }
        },
        generateSpectrumCustomId(spectrumJobNumberCustomFieldId){
            let customFieldsArray = this.$parent.$refs.CustomFields.custom_fields;

            const customProjectIdField = customFieldsArray.find(field =>
                field.id === parseInt(spectrumJobNumberCustomFieldId) &&
                field.spectrum_project_custom_id_auto_generated === 1
            );

            if (!customProjectIdField) return null;

            const customId = [];
            let separator = '';

            const newState = customProjectIdField.spectrum_project_custom_id_data;

            for (const element of newState) {
                if (element.value) {
                    let value;
                    if (element.sequential) {
                        switch (element.id) {
                            case 'year':
                                value = new Date().getFullYear();
                                break;
                            case 'month':
                                value = new Date().getMonth() + 1;
                                break;
                            case 'day':
                                value = new Date().getDate();
                                break;
                            case 'system_generated':
                                value = this.project.sequential_team_id;
                                break;
                        }
                    } else if (element.start_from) {
                        value = element.input_value;
                        if(element.id == 'system_generated'){
                            this.nextAutoGeneratedStartFrom = parseInt(element.input_value) + 1;
                        }
                    }
                    if (value !== undefined) {
                        customId.push(value);
                    }
                }

                if (element.id === 'other' && element.value) {
                    separator = element.seperated_by_dash ? '-' : (element.seperated_by_space ? '/' : '');
                }
            }
            this.isCustomIdAutoGenerated = true;

            return separator ? customId.join(separator) : customId.join('');
        },
        syncProjectSpectrumInvoice(refresh = false){
            this.$parent.$refs.SpectrumIncomeCost.syncProjectSpectrumInvoice(true);
        },
    }
}
</script>
